interface StoreLinks {
  appStore: string;
  playStore: string;
}

/** App para clientes de Hosty (dueños/gestores de negocio): informes, licencias y soporte. */
export const CLIENT_APP_LINKS: StoreLinks = {
  appStore: 'https://apps.apple.com/es/app/id6780600681',
  playStore: 'https://play.google.com/store/apps/details?id=com.tpvhosty.client',
};

/** App interna para agentes de soporte de Hosty (gestión de tickets en movilidad). */
export const STAFF_APP_LINKS: StoreLinks = {
  appStore: 'https://apps.apple.com/es/app/id6780599822',
  playStore: 'https://play.google.com/store/apps/details?id=com.tpvhosty.staff',
};
